exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nnav.alerts-nav[data-v-22509a55] {\n  width: 100%;\n  height: 50px;\n  text-align: center;\n  line-height: 153px;\n  background-color: #f7f7f7;\n  font-size: 24px;\n}\n", "", {"version":3,"sources":["/codebuild/output/src561637037/src/src/components/ui/nav/AlertsNav.vue"],"names":[],"mappings":";AAkCC;EACC,YAAW;EAAE,aAAY;EACnB,mBAAkB;EAClB,mBAAkB;EAClB,0BAAyB;EACzB,gBAAe;CACrB","file":"AlertsNav.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\tnav.alerts-nav {\n\t\twidth: 100%; height: 50px;\n        text-align: center;\n        line-height: 153px;\n        background-color: #f7f7f7;\n        font-size: 24px;\n\t}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22509a55","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/nav/AlertsNav.vue
// module id = O46o
// module chunks = 1